// Sentry MUST be initialized FIRST, before any other imports.
// Feb 2026 launch hardening — see /app/memory/PRD.md iter111.
import * as Sentry from "@sentry/react";

const sentryDsn = process.env.REACT_APP_SENTRY_DSN || "";
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "production",
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations: [
      Sentry.browserTracingIntegration({
        tracePropagationTargets: [/^\/api/, /\/api\//],
      }),
    ],
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "Non-Error promise rejection captured",
    ],
    beforeSend(event, hint) {
      const error = hint && (hint.originalException || hint.syntheticException);
      if (error && typeof error.message === "string") {
        if (
          /NetworkError/i.test(error.message) ||
          /Failed to fetch/i.test(error.message) ||
          /Load failed/i.test(error.message) ||
          /AbortError/i.test(error.message)
        ) {
          return null;
        }
      }
      return event;
    },
  });
}

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<DefaultFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

function DefaultFallback() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "#f8fafc" }}>
      <div style={{ maxWidth: 480, background: "white", padding: 32, borderRadius: 12, boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }} data-testid="sentry-fallback">
        <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0, color: "#000B3A" }}>Something went wrong</h1>
        <p style={{ marginTop: 12, color: "#475569", lineHeight: 1.5 }}>
          An unexpected error occurred. Our team has been automatically notified. You can reload the page to try again.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{ marginTop: 20, padding: "10px 20px", background: "#005CFF", color: "white", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600 }}
          data-testid="sentry-fallback-reload"
        >
          Reload page
        </button>
      </div>
    </div>
  );
}
